function objectFitPolyfill() {
    var _a, _b;
    var objectFitImages = document.querySelectorAll('[data-object-fit]');
    for (var i = 0; i < objectFitImages.length; i++) {
        var image = objectFitImages[i];
        var src = image.getAttribute('data-src') || image.getAttribute('src');
        var parent_1 = void 0;
        var target = void 0;
        if (((_a = image.parentElement) === null || _a === void 0 ? void 0 : _a.tagName) === 'PICTURE') {
            parent_1 = (_b = image.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement;
            target = image.parentElement;
        }
        else {
            parent_1 = image.parentElement;
            target = image;
        }
        parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.setAttribute('style', "background: url(\"".concat(src, "\") no-repeat center center/cover"));
        parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.removeChild(target);
    }
}
export default objectFitPolyfill;
